<template>
    <div>
        <ul class="highlights-component" ref="highlightsBlock" v-if="highlights">
            <li class="highlight highlights-component__highlight" v-for="(highlight, index) in highlights"
                :key="highlight.id">
                <button class="highlight__button" type="button" @click="handleButtonClick(highlight.id)">
                    <img class="highlight__image" :src="highlight.preview"
                        @error="handleLoadErrorImage(index)" :ref="`image-${index}`" alt="cover" />
                    <p class="highlight__title">{{ highlight.title }}</p>
                </button>
            </li>
        </ul>
    </div>

</template>

<script>
import { IgApi } from "../api/instagram";
import noHighlightImagePicture from "../../img/placeholder/no-highlight-image.jpg";
import adaptStories from "../tools/adaptStories";
import horizontalScrollOnMouseWheel from '../tools/horizontalScroll'
export default {
    name: "HighlightsComponent",
    props: {
        highlights: {
            type: Array,
            required: true
        },
        abortController: {
            type: AbortController,
            required: true
        }
    },
    data() {
        return {
            newAbortController: null,
        };
    },
    mounted: function () {
        if(this.$refs.highlightsBlock){
            horizontalScrollOnMouseWheel(this.$refs.highlightsBlock, 50);
        }
        if(!this.highlights || this.highlights.length === 0){
            this.$root.$emit("handleError", null, "No highlights found");
        }
    },
    methods: {
        async handleButtonClick(highlightId) {
            this.$emit("dropHighlight");
            this.$emit("startLoading");
            const response = await this.requestHightlightStories(highlightId);
            this.$emit("stopLoading");
            const stories = adaptStories(response);
            this.$emit("highlightClick", stories, this.newAbortController);
        },
        async requestHightlightStories(highlightId) {

            if (this.abortController) {
                this.abortController.abort();
            }

            this.newAbortController = new AbortController();

            try {
                return IgApi.getHighlightStoriesById({
                    highlightId: highlightId,
                    subscribeSignedRequestBody: this.$root.subscribeSignedRequestBody,
                    signal: this.newAbortController.signal,
                }).then((response) => response.data.result)
            } catch (error) {
                if (error.response?.status === 429) {
                    this.$emit("handleError", error.response, "Too many requests. Please try again later");
                }
                return [];
            }
        },
        handleLoadErrorImage(index) {
            this.$refs[`image-${index}`][0].src = noHighlightImagePicture;
        },
    },
};
</script>
